/* eslint-disable  */
import ReactGA from 'react-ga4';

// — initialize with your GA4 Measurement ID
export function initAnalytics() {
  ReactGA.initialize('G-NT4BL01M24', {
    gaOptions: {
      debug_mode: true
    },
    gtagOptions: {
      debug_mode: true
    }
  });
}

function getIndianDateTime() {
  // produce something like "28/05/2025, 15:15:09"
  const local = new Date().toLocaleString('en-IN', {
    timeZone: 'Asia/Kolkata',
    year:   'numeric',
    month:  '2-digit',
    day:    '2-digit',
    hour:   '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  });
  // remove the comma and any extra spacing
  return local.replace(',', '');
}
// — log each React-Router pageview
export function logPageView(path) {
  ReactGA.send({ hitType: 'pageview', page: path });
}

// — set the authenticated user ID (no PII!)
export function setUserId(userId) {
  ReactGA.set({ user_id: userId });
}

// sets any GA4 user properties (e.g. username); these appear under “User → User Properties”
export function setUserProperties(props) {
  // gtag('set', { user_properties: props })
  ReactGA.gtag('set', { user_properties: props });
}

// — generic event (for API calls, statuses, etc)
export function logEvent({ category, action, label, value }) {
  ReactGA.event({ category, action, label, value });
}

// — timing event (for login time, API duration, etc)
export function logTiming({ category, variable, value, label }) {
  ReactGA.timing({ category, variable, value, label });
}


export function logLogin({ username }) {
  const timestamp = new Date().toISOString();
 ReactGA.gtag('event', 'login', {
    username,
    // e.g. "28/05/2025 15:15:09"
    login_timestamp: getIndianDateTime()
  });
}